/**
 * @author Jorge Casas
 * @creationDate 22/04/2024
 */

import React from 'react';
import { translate } from 'react-i18next';
import * as Common from 'common/components';

const UsersTable = ({
  children,
  count = 0,
  company,
  subcompany,
  t = () => {},
  //   order,
  //   orderBy,
  //   handleOrderChange,
}) => {
  const headers = [
    {
      variable: 'customsDocumentsPedimentoNumber',
      text: t('acl.assetsCustomsDocuments.pedimento_number'),
    },
    { variable: 'customsDocumentsCustomsKey', text: t('acl.assetsCustomsDocuments.customs_key') },
    { variable: 'customsDocumentsDate', text: t('acl.assetsCustomsDocuments.date') },
    {
      variable: 'customsDocumentsPedimentoKey',
      text: t('acl.assetsCustomsDocuments.pedimento_key'),
    },
    { variable: 'customsDocumentsAssetStatus', text: t('acl.assetsCustomsDocuments.status') },
    { variable: 'customsDocumentsImport', text: t('acl.assetsCustomsDocuments.import') },
    { variable: 'customsDocumentsQuantity', text: t('acl.assetsCustomsDocuments.quantity')},
    { variable: 'customsDocumentsFile', text: t('acl.assetsCustomsDocuments.files') },
  ];

  const config = {
    // editPermission: 'acl.users.update',
    // togglePermission: 'acl.users.toggle',
    // editUrl: 'users', //Url para editar empleado
    propsName: '_customsDocuments', //de donde se obtienen los props
    // company: company,
    // subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    // handleClick: handleToggle,
  };

  return (
    <div className="table-responsive" style={{ position: 'relative' }}>
      <Common.List dataCard={dataCard}>
        {/* <table className="table table-hover table-striped"> */}
        <thead>
          <tr>
            <Common.ThSortable
              //   orderBy={orderBy}
              //   order={order}
              field="customsDocumentsPedimentoNumber"
              //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsCustomsDocuments.pedimento_number')}
            </Common.ThSortable>
            <Common.ThSortable
              //   orderBy={orderBy}
              //   order={order}
              field="customsDocumentsPedimentoKey"
              //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsCustomsDocuments.pedimento_key')}
            </Common.ThSortable>
            <Common.ThSortable
              //   orderBy={orderBy}
              //   order={order}
              field="customsDocumentsCustomsKey"
              //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsCustomsDocuments.customs_key')}
            </Common.ThSortable>
            <Common.ThSortable
              //   orderBy={orderBy}
              //   order={order}
              field="customsDocumentsDate"
              //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsCustomsDocuments.date')}
            </Common.ThSortable>
            <Common.ThSortable
              //   orderBy={orderBy}
              //   order={order}
              field="customsDocumentsStatus"
              //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsCustomsDocuments.status')}
            </Common.ThSortable>
            <Common.ThSortable
              //   orderBy={orderBy}
              //   order={order}
              field="customsDocumentsImport"
              //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsCustomsDocuments.import')}
            </Common.ThSortable>
            <Common.ThSortable
              //   orderBy={orderBy}
              //   order={order}
              field="customsDocumentsQuantity"
              //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsCustomsDocuments.quantity')}
            </Common.ThSortable>
            <Common.ThSortable
              //   orderBy={orderBy}
              //   order={order}
              field="customsDocumentsFile"
              //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsCustomsDocuments.files')}
            </Common.ThSortable>
            <Common.ThSortable
              //   orderBy={orderBy}
              //   order={order}
              field="customsDocumentsCreatedAt"
              //   handleOrderChange={handleOrderChange}
            >
              {t('acl.assetsCustomsDocuments.createdAt')}
            </Common.ThSortable>
          </tr>
        </thead>
        <tbody>
          {!count && <Common.EmptyTable colSpan={6} />}
          {children}
        </tbody>
      </Common.List>
      {/* </table> */}
      <Common.LoaderOverlay />
    </div>
  );
};

export default translate()(UsersTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/assets/AssetCustomsDocumentsTable.js